import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ActionJsonModel, ActionSchema } from '../../domain/collection/rule/action/ActionDomains';

export type ActionActions =
  | 'CHANGE_ACTION'
  | 'CHANGE_ACTION_SCHEMA'
  | 'CHANGE_ACTION_IS_UPDATE'
  | 'CLEAR_ACTION'
  | 'CHANGE_ACTION_API_VARIABLE_URL'
  | 'CHANGE_ACTION_DIRTY';

export const changeAction = (payload: ActionJsonModel | null) =>
  ({
    type: 'CHANGE_ACTION',
    payload,
  }) as ReduxBaseAction<ActionJsonModel, ActionActions>;

export const changeActionSchema = (payload: ActionSchema | null) =>
  ({
    type: 'CHANGE_ACTION_SCHEMA',
    payload,
  }) as ReduxBaseAction<ActionSchema | null, ActionActions>;

export const changeActionIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_ACTION_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, ActionActions>;

export const clearAction = () =>
  ({
    type: 'CLEAR_ACTION',
    payload: void 0,
  }) as ReduxBaseAction<void, ActionActions>;

export const changeActionApiVariableParameter = (payload: ActionJsonModel) =>
  ({
    type: 'CHANGE_ACTION_API_VARIABLE_URL',
    payload,
  }) as ReduxBaseAction<any, ActionActions>;

export const changeActionDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_ACTION_DIRTY',
    payload,
  }) as ReduxBaseAction<any, ActionActions>;
